<template>
  <el-radio-group v-model="computedValue" :disabled="!editable">
    <el-radio
      v-for="item in config.options"
      :key="item.baseQuestionOptionId"
      :label="String(item.baseQuestionOptionId)"
      >{{ item.baseQuestionOptionName }}</el-radio
    >
  </el-radio-group>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
};
</script>

<style lang="scss" scoped></style>
